import React, { useState, useEffect } from 'react'
import pathname from '../../constants/pathname'
import ProjectDataTable from '../dataTable/ProjectDataTable'
import { useHistory } from 'react-router-dom'
import { getWaitApproval } from '../../redux/actions/dashboard'
import { Message } from 'rsuite'
import DashboradToggle from './DashboradToggle'
import TableLoadingTemplate from '../loadingTemplate/tableLoadingTemplate/TableLoadingTemplate'
import { sessionSetItemObj } from '../../utils/sessionHelpers'

export default function ApprovalBudget({ ...props }) {
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [status, setStatus] = useState('0')
  let history = useHistory()
  const { enableMulti, config, onSettingChange } = props

  useEffect(() => {
    if (config) {
      setSchema(settingSchema)
    } else {
      handelGetSchemaDashboard(5, 1)
    }
  }, [])

  const handelGetSchemaDashboard = async (
    pagesize,
    pagenumber,
    projectCodeSearch,
    projectNameSearch,
    _reviewType,
    status
  ) => {
    setIsLoading(true)
    try {
      const response = await getWaitApproval(
        pagesize,
        pagenumber,
        projectCodeSearch,
        projectNameSearch,
        status
      )
      setSchema(response)
      setStatus(status || '0')
      setError('')
    } catch (e) {
      setError(`เกิดข้อผิดผลาดในการแสดงโครงการที่รออนุมัติ ${enableMulti ? 'ทุน' : ''}`)
    }
    // doneLoading()
    setIsLoading(false)
  }

  const onMultiSubmit = (statusBox) => {
    console.log('Multi-approve onSubmit', statusBox)

    let url = ''

    if (statusBox == 1) {
      url = pathname.proposal.approve.approveProjectMulti
    } else if (statusBox == 2) {
      url = pathname.proposal.approve.approveDisbursementMulti
    } else if (statusBox == 3) {
      url = pathname.proposal.approve.approveContractMulti
    } else if (statusBox == 4) {
      url = pathname.proposal.approve.approveClosureMulti
    } else if (statusBox == 5) {
      url = pathname.proposal.approve.approveTerminateMulti
    } else if (statusBox == 6) {
      url = pathname.proposal.approve.approveCancelMulti
    } else {
      url = pathname.proposal.approve.approveProjectMulti
    }

    sessionStorage.setItem('projectId', statusBox ? 0 : 1)
    sessionStorage.setItem('param', `?${statusBox || 1}`)

    window.location.href = `${url}`
    window.opener = null

    // return history.push({
    //   pathname: `${url}/${statusBox || 1}?${statusBox ? 0 : 1}`,
    //   //state: { selectId: idList },
    // })
  }

  const onSingleSubmit = (obj, statusBox) => {
    sessionStorage.setItem('projectId', obj.id)
    sessionStorage.setItem('param', '')

    if (statusBox == 7 || obj.id.length > 36) {
      let arr = obj?.id?.split('|')
      let projectReviewerPayment = {
        paymentType: arr[0],
        projectReviewerPaymentId: arr[1],
        masterReviewerId: arr[2],
        code: arr[3],
        projectVersionId: arr[4],
        status: arr[5],
        projectName: obj.projectName.name || '',
      }

      sessionSetItemObj('projectReviewerPayment', projectReviewerPayment)

      if (projectReviewerPayment.paymentType == 2) {
        window.location.href = `${pathname.admin.adminWithdrawalReview.withdrawReview}`
        window.opener = null
        return
      }

      if (projectReviewerPayment.paymentType == 1) {
        window.location.href = `${pathname.admin.adminWithdrawalReview.withdrawReviewByReviewer}`
        window.opener = null
        return
      }
    }
    window.location.href = `${pathname.proposal.overview.overviewCoworker}`
    // window.location.href = `${pathname.proposal.overview.overviewCoworker}/${obj.id}`
    window.opener = null
    //history.push(`${pathname.proposal.overview.overviewCoworker}/${obj.id}`)
  }

  // filter
  if (!schema) {
    return <TableLoadingTemplate />
  }

  return (
    <>
      {error && (
        <Message
          style={{ marginTop: 20, marginBottom: -10 }}
          closable
          showIcon
          type="error"
          description={error}
        />
      )}

      {schema && (
        <>
          {config && (
            <DashboradToggle
              onChange={onSettingChange}
              dashboradName={config.key}
              checked={config.show}
              style={{ marginTop: 20, marginBottom: -15 }}
            />
          )}
          <ProjectDataTable
            schema={schema}
            subName={{ enable: true }}
            // multi={{
            //   enable: enableMulti,
            //   buttonText: `ไปยังอนุมัติทุนหลายโครงการ`,
            //   disableSelect: true,
            //   showIsNodata: true,
            //   icon: 'arrow-circle-right',
            // }}
            submit={{
              enable: ['0', '1', '2', '3', '4'].includes(status) ? enableMulti : false,
              buttonText: `อนุมัติ`,
              disableSelect: true,
              showIsNodata: true,
              icon: 'arrow-circle-right',
              preText: 'ไปยัง',
              postText: 'หลายโครงการ',
            }}
            single={{
              enable: true,
              buttonText: schema?.buttonText,
            }}
            onSingleSubmit={onSingleSubmit}
            // onMultiSubmit={onMultiSubmit}
            onSubmit={onMultiSubmit}
            pagination={true}
            onReload={handelGetSchemaDashboard}
            loading={isLoading}
            searchEnable={true}
            setting={config && true}
          />
        </>
      )}
    </>
  )
}

const settingSchema = {
  header: 'รายการที่รออนุมัติ',
  projectCodeText: 'รหัสโครงการ',
  projectNameText: 'ชื่อโครงการ',
  projectTypeText: 'ประเภทโครงการ',
  projectBudgetText: 'งบประมาณรวม',
  buttonText: 'แสดง',
  totalSize: 1,
  buttonFilterStatus: [
    { buttonText: 'อนุมัติโครงการ', countStatus: 1, colorStatus: '#92CEA8', status: '1' },
    { buttonText: 'อนุมัติเบิกจ่าย', countStatus: 0, colorStatus: '#8BD2EC', status: '2' },
    { buttonText: 'อนุมัติแก้ไขสัญญา', countStatus: 0, colorStatus: '#FCEE9E', status: '3' },
    { buttonText: 'อนุมัติปิด', countStatus: 0, colorStatus: '#C0E4F6', status: '4' },
    { buttonText: 'อนุมัติสละสิทธิ์', countStatus: 0, colorStatus: '#E8CFF8', status: '5' },
    { buttonText: 'อนุมัติยุติ/ยกเลิก', countStatus: 0, colorStatus: '#ADD495', status: '6' },
  ],
  values: [
    {
      id: '',
      projectCode: 'XX-XXXXX',
      projectName: {
        name: 'โครงการ XXXXX',
        statusName: 'สาถนะ XXX',
      },
      projectBudget: '9,999,999.99',
      projectType: { value: 'โครงการ', label: '1' },
    },
  ],
}
